'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/26.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HoverComponent = require('../HoverComponent/HoverComponent');

var _HoverComponent2 = _interopRequireDefault(_HoverComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceMarketMiddleFilterItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceMarketMiddleFilterItem, _Component);

  function ServiceMarketMiddleFilterItem() {
    (0, _classCallCheck3.default)(this, ServiceMarketMiddleFilterItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceMarketMiddleFilterItem).call(this));

    _this.state = {
      middleData: [{
        'id': '',
        'name': '全部分类',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg1.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_1_tx.png'
      }, {
        'id': '02',
        'name': '艺品鉴定',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg2.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_2_tx.png'
      }, {
        'id': '08',
        'name': '艺品加工',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg3.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_3_tx.png'
      }, {
        'id': '09',
        'name': '视觉设计',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg4.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_4_tx.png'
      }, {
        'id': '11',
        'name': '艺品设计',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg5.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_5_tx.png'
      }, {
        'id': '04',
        'name': '商品资讯',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg6.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_6_tx.png'
      }, {
        'id': '10',
        'name': '艺品摄影',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg7.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_7_tx.png'
      }, {
        'id': '07',
        'name': '其它',
        'img': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg8.jpg',
        'imgTitle': 'http://tupian.goeasy.cn:9999/yipinwang/third/ding_er_bg_8_tx.png'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceMarketMiddleFilterItem, [{
    key: 'onSecondItemClick',
    value: function onSecondItemClick(item) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        onItemClick(item.id);
      }
    }
  }, {
    key: 'itemClick',
    value: function itemClick(filterStr) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        onItemClick(filterStr);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ServiceMarketMiddleFilterItem.scss');
      var filterLevel = this.state.middleData;
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.ding_img },
          _react2.default.createElement(_HoverComponent2.default, { onItemClick: this.onSecondItemClick.bind(this), data: filterLevel[0] })
        ),
        _react2.default.createElement(
          'ul',
          { className: styles.mfw_sx_ul },
          filterLevel.map(function (currentItem, index) {
            var returnResult = '';
            if (index > 0 && index < 7) {
              returnResult = _react2.default.createElement(
                'li',
                { key: index, className: index < 4 ? styles.mb : '' },
                _react2.default.createElement(_HoverComponent2.default, { onItemClick: _this2.onSecondItemClick.bind(_this2), data: currentItem })
              );
            }
            return returnResult;
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.ding_img + ' ' + styles.ml6 },
          _react2.default.createElement(_HoverComponent2.default, { onItemClick: this.onSecondItemClick.bind(this), data: filterLevel[7] })
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ServiceMarketMiddleFilterItem;
}(_react.Component), _class.propTypes = {
  texts: _react.PropTypes.array,
  onSearch: _react.PropTypes.func,
  onItemClick: _react.PropTypes.func
}, _temp);
exports.default = ServiceMarketMiddleFilterItem;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceMarketMiddleFilterItem/ServiceMarketMiddleFilterItem.js
 ** module id = 1417
 ** module chunks = 0
 **/